import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { TextFieldInput } from "../../../../../components/form-inputs";
import { SensorDataStore } from "../../../store/store";

export interface HeartbeatMinInputProps {
    disabled: boolean;
    sensorDataStore?: SensorDataStore;
}

export const ERRORKEY_MAP: Record<string, string> = {
    "number.min": "MinMaxValueHeartBeat",
    "number.max": "MinMaxValueHeartBeat",
};

function HeartbeatMinInput(props: HeartbeatMinInputProps) {
    const sensorDataStore = props.sensorDataStore!;
    const { errorMessages } = sensorDataStore;

    const { t } = useTranslation("sensor-grid");
    const HeartbeatMin =
        sensorDataStore.selectedSensor.heartbeatMonitoringIntervalTimeInMinutes;

    const mapedErrors = () => {
        let errorStringList: string[] = [];

        if (
            errorMessages &&
            errorMessages["heartbeatMonitoringIntervalTimeInMinutes"]
        ) {
            errorStringList = errorMessages[
                "heartbeatMonitoringIntervalTimeInMinutes"
            ].map((error) => {
                return ERRORKEY_MAP[error];
            });
        }

        return errorStringList;
    };

    const renderErrorList = () => {
        const errorList = mapedErrors();

        if (errorList.length === 0) {
            return null;
        }

        const list = errorList.map((errorText) => {
            return <li>{t(errorText)}</li>;
        });

        return (
            <ul style={{ margin: 0, padding: 0, paddingLeft: "5px" }}>
                {list}
            </ul>
        );
    };

    return (
        <TextFieldInput
            errorMessage={renderErrorList()}
            disabled={props.disabled}
            value={HeartbeatMin}
            inputProps={{
                maxLength: 4,
            }}
            label={t("HeartbeatMinutes").toUpperCase()}
            onChange={(event) => {
                const { value } = event.target;
                let valueNumber = Number(value);

                if (isNaN(valueNumber)) return;

                sensorDataStore!.setSelectedSensorHeartbeatMin(valueNumber);
                sensorDataStore.validateSelectedSensor(
                    "heartbeatMonitoringIntervalTimeInMinutes"
                );
                sensorDataStore.setSelectedSensorHasChanges(true);
            }}
        />
    );
}

export default inject("sensorDataStore")(observer(HeartbeatMinInput));
